module.exports = __webpack_public_path__ + "img/72_9.ea2b26a7.png";